
<div class="app">
  <nav class="app__bar">
    <h1>Rule Builder</h1>
  </nav>

  <section class="app__container">
    <aside class="app__nav">
      <h4>PLUGINS</h4>

      <ul>
        <li class="active">
          URL REWRITE

          <ul>
            <li class="active">PATH REWRITE</li>
            <li>QUERY REWRITE</li>
            <li>HEADERS REWRITE</li>
          </ul>
        </li>
        <li>BLACK RULES</li>
      </ul>
    </aside>

    <aside class="app__nav app__rule_nav">
      <h3>Path Rewrite</h3>

      <ul>
        <li>
          req.path.uri == "/api/v1/hello" && req.path.uri == "/api/v1/hello2"

          <button>Edit</button>
          <button>Delete</button>
        </li>
        <li>
          req.path.uri == "/hello" && req.geo.country == "US"
          <button>Edit</button>
          <button>Delete</button>
        </li>

        <li>
          req.path.uri == "/hello" && req.geo.country == "US" && req.headers["x-hello"] == "world"
          <button>Edit</button>
          <button>Delete</button>
        </li>
      </ul>

      <button class="btn-primary">Add Rule</button>
    </aside>

    <main class="app__content">
      <RuleBuilder />
    </main>
  </section>
</div>
